module.exports = __webpack_public_path__ + "static/media/song1.c894dd22.mp3";